import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { isLoggedIn } from '../services/api'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/List',
    name: 'List',
    component: () => import('../views/List.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/addList',
    name: 'addList',
    component: () => import('../views/addList.vue'),
    meta: { requiresAuth: true }
  },
    {
    path: '/BillOfMaterials',
    name: 'BillOfMaterials',
    component: () => import('../views/components/BillOfMaterials.vue'),
    meta: { requiresAuth: true }
  },
    {
    path: '/switchs',
    name: 'switchs',
    component: () => import('../views/components/switchs.vue'),
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 检查路由是否需要认证
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 检查是否已登录
    if (!isLoggedIn()) {
      // 未登录，重定向到登录页
      next({
        path: '/',
        query: { redirect: to.fullPath }
      })
    } else {
      // 已登录，放行
      next()
    }
  } else {
    // 不需要认证的路由，放行
    next()
  }
})

export default router
